import { AfterViewInit, Component, DoCheck, ElementRef, HostListener, OnDestroy, OnInit, QueryList, Renderer2, ViewChild, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { IonContent, Platform } from '@ionic/angular';
import { AppState } from 'src/app/app.service';
import { I18n } from 'src/app/i18n.service';
import { InoutScreen } from 'src/app/inout-screen/inout-screen.model';
import { Path } from 'src/app/path/path.model';
import * as _ from 'underscore';
import { HomeUiService } from '../home-ui.service';
import { ModalController } from '@ionic/angular';
import { User } from 'src/app/user/user.model';
import { ToasterService } from 'src/app/toaster.service';
import { HomeV5Service } from 'src/app/pages/home-v5/home-v5.service';
import { HttpClient } from '@angular/common/http';
import Swiper from 'swiper';
import { DailyStepsContentModalComponent } from '../daily-steps-content-modal/daily-steps-content-modal.component';
import { AnimationsService } from 'src/app/shared/animations.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { MyCommitmentsComponent } from 'src/app/my-commitments/my-commitments.component';
import { AllPathsComponent } from 'src/app/all-paths/all-paths.component';
import { AlertUnlockLevelComponent } from 'src/app/alert-unlock-level/alert-unlock-level.component';
import { SessionService } from 'src/app/session/session.service';
import { RoutineService } from 'src/app/daily-content-v2/routine.service';
import { FooziAiConciergeService } from '../foozi-ai-concierge.service';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { collapseAnimation, collapseOnLeaveAnimation, expandOnEnterAnimation, slideOutRightAnimation } from 'angular-animations';

export interface ExcludedSteps {
  steps,
  completedSteps,
  activeStep,
  notStartedStep,
  totalSteps
}
@Component({
  selector: 'app-your-path-new',
  templateUrl: './your-path-new.component.html',
  styleUrls: ['./your-path-new.component.scss'],
  animations: [
   slideOutRightAnimation({duration: 500}),
   collapseAnimation(),
   expandOnEnterAnimation({ duration: 250 }),
   collapseOnLeaveAnimation({ duration: 250 })
  ]
})
export class YourPathNewComponent implements OnInit, AfterViewInit,DoCheck,OnDestroy {

  isMobile: boolean
  inoutScreens: InoutScreen[]
  path: Path
  currentDay: number
  @ViewChildren("stepTitle") stepTitle: QueryList<ElementRef>;
  @ViewChildren("stepTitleStart") stepTitleStart:QueryList<ElementRef>;
  @ViewChildren("stepTitleEnd") stepTitleEnd:QueryList<ElementRef>;
  @ViewChild('focusableEndChapter') focusableEndChapter: ElementRef;
  @ViewChild(IonContent) content: HTMLIonContentElement;
  @ViewChild('contentWrapper') contentWrapper: ElementRef;
  @ViewChild('scrollContainer', { static: false }) scrollContainer!: ElementRef;
  @ViewChildren('chapterCard') chapterCards: QueryList<ElementRef>;
  @ViewChildren('stepCards') stepCards: QueryList<ElementRef>;
  @ViewChildren('finishStepCards') finishStepCards: QueryList<ElementRef>; 
  currentUser: User
  pathRegistration: any
  scheduleDay: number
  focusYourPath=false;
  sectionSize = [];
  rightSwipe;
  leftSwipe;
  isHovered = false;
  startPlayButton;
  onFocusPlayBtn;
  dailyStepsArray;
  blurPlayButton;
  @ViewChild('swiperContainer') swiperContainer: any;
  swiper: Swiper;
  destroyed$ = new Subject<boolean>();
  playSvg;
  closeoutSvg;
  onFocuseCloseOut;
  isBtnFocused =false;
  isMobileWebIos = false;
  isMobileWeb=false;
  startCloseout;
  isScrollbarPresent;
  allPathsCount;
  isTouchDevice
  isModalOpen = false;
  expandedIndex: number | null = null;
  isExpandedCard1 = false;
  isExpandedCard2 = false;
  chaptersInfo: any =[]; // static data
  finalSortedChaptersInfo=[]
  initialChapterStepsInfo:ExcludedSteps;
  finalChaptertepsInfo:ExcludedSteps;
  finalizedChapterIds = []
  userShuffledChapters;
  pathPersonalizationScreeInfo;

  constructor(private appState: AppState,
    private router: Router,
    private el : ElementRef,
    public i18n: I18n,
    public http: HttpClient,
    public platform: Platform,
    private modalController: ModalController,
    private homeUIService: HomeUiService,
    private render:Renderer2,
    private homev5Service: HomeV5Service,
    private animationService: AnimationsService,
    private sessionService: SessionService,
    private routineService: RoutineService,
    public toasterService: ToasterService, private fooziAiService: FooziAiConciergeService) {
    this.isMobile = this.appState.get('isMobile')
    this.path = this.appState.get('currentPath')
    this.currentDay = this.appState.get('currentScheduleDay')
    this.currentUser = this.appState.get('currentUser')
    this.scheduleDay = this.appState.get("scheduleDayForCurrentStep")
    this.pathRegistration = this.appState.get('pathRegistration')
    this.dailyStepsArray= this.appState.get("DailyStepsData");
    this.inoutScreens = this.fetchScreenTypeContent('inoutScreens')

    this.sectionSize = [
      {
        size:4, sizeMd:4,sizeSm:5,sizeLg:3.5,sizeXl:3
       },
      {
        size:8, sizeMd:8,sizeSm:7,sizeLg:8.5,sizeXl:9
      }
    ]
   }
 
  fetchScreenTypeContent(screentype) {
   let dailyStepsArray = this.appState.get('DailyStepsData')
    return dailyStepsArray
      .map(step => step?.[screentype])
      .filter(s => s != null && (Array.isArray(s) ? s?.length > 0 : true))
      .flatMap(s => Array.isArray(s) ? s : [s]);
  }
  ngOnInit() {
    this.isMobileWeb = this.appState.get('MobileWeb')
    this.isMobileWebIos = this.appState.get('MobileWebIos');
    this.userShuffledChapters = this.appState.get('userShuffledChapters');
    this.chaptersInfo = this.path?.chapters;
    console.log("this.isMobileWeb value", this.isMobileWeb);
    this.allPathsCount =  this.appState.get('allPathCount')
    this.loadSvgFile('../../../assets/web_home_ui/white_play_btn.svg');
    this.loadSvgFile('../../../assets/web_home_ui/black_play_btn.svg');
    this.loadSvgFile('../../../assets/web_home_ui/black_circular-to-do.svg');
    this.loadSvgFile('../../../assets/web_home_ui/white_circular_to-do.svg');
    this.loadSvgFile('../../../assets/web_home_ui/blur-play-btn.svg');
   this.getStepArrayInfo();
   this.homeUIService.refreshStepApiData.pipe(takeUntil(this.destroyed$)).subscribe( (data) => {
    if(data){
      console.log("data in your path", data);
      this.dailyStepsArray = data.data;
      let time= this.isMobile?0:500
      //this.fetchChaptersSteps()
      this.updateChpaterStepStatus();
      //this.expandCorrectChapter()
      // setTimeout(async () => {
      //   await this.swipeToActiveSlide(100); 
      // },time);
    }
  
  });
  this.fooziAiService.expandHamburger.pipe(takeUntil(this.destroyed$)).subscribe((data) => {
    let col1, col2;
    this.sectionSize = [];
    console.log("called datat",data)
    if (data) {
       col1 = {
        size:5, sizeMd:5,sizeSm:6,sizeLg:4.5,sizeXl:4.5
      }
      col2 = {
        size:7, sizeMd:7,sizeSm:6,sizeLg:7.5,sizeXl:7.5
      }
      this.sectionSize.push(col1,col2)
    }
    else {
       col1 = {
        size:4.5, sizeMd:4.5,sizeSm:5,sizeLg:3.5,sizeXl:3
       }
      col2 = {
        size:7.5, sizeMd:7.5,sizeSm:7,sizeLg:8.5,sizeXl:9
      }
      this.sectionSize.push(col1,col2);
    }
  });
    this.fetchChaptersSteps()
  }

  updateChpaterStepStatus() {
    if ((this.finalSortedChaptersInfo?.length<this.chaptersInfo?.length ||this.finalSortedChaptersInfo?.length==0) &&this.userShuffledChapters && this.userShuffledChapters?.chapterOrder) {
        // Find chapters NOT in order list
        const missingChapters = this.chaptersInfo.filter(c => !this.userShuffledChapters.chapterOrder.includes(c.id));

        const orderedChapters = this.userShuffledChapters?.chapterOrder
          .map(id => this.chaptersInfo.find(c => c.id === id))
          .filter(Boolean); // remove undefined if any

        // Final reordered chapters (missing first, then ordered ones)
        this.finalSortedChaptersInfo = [...missingChapters, ...orderedChapters];
      // Update the initial chapter steps info
    }
    if (this.finalSortedChaptersInfo?.length > 0) {
      if (this.userShuffledChapters && this.userShuffledChapters?.chapterOrder) {
        this.scheduleDay = this.appState.get('scheduleDayForCurrentStep')
         let startIndex=0;
         let endIndex =this.initialChapterStepsInfo?.totalSteps>0?this.initialChapterStepsInfo?.totalSteps:0 ;
        this.finalSortedChaptersInfo.forEach((chapter) => {
          startIndex = endIndex + 1
           endIndex = startIndex+ (chapter.endStep - chapter.startStep)
          //  const includedSteps = this.dailyStepsArray.filter(
             
          //    s => s.step >= startIndex && s.step <= endIndex
          //  );
          const includedSteps = this.dailyStepsArray
             .filter(s => s.originalStep >= chapter.startStep && s.originalStep <= chapter.endStep)
             .sort((a, b) => a.originalStep - b.originalStep);
     
          chapter.steps = includedSteps;
          chapter.completedSteps = includedSteps?.filter(s => s?.stepStatus == 'Review')?.length;
          chapter.activeStep = includedSteps?.filter(
            s => s.stepStatus == 'Resume' || (s.step == this.scheduleDay && s.stepStatus !== 'Review')
          )?.length;
          chapter.notStartedStep = includedSteps.filter(
            s => s.step == this.scheduleDay && !s.stepStatus
          )?.length;
          chapter.totalSteps = includedSteps?.length;
        });
      }
      else {
        this.scheduleDay = this.appState.get('scheduleDayForCurrentStep')
        this.finalSortedChaptersInfo?.forEach((chapter) => {
          const includedSteps = this.dailyStepsArray.filter(
            s => s.step >= chapter.startStep && s.step <= chapter.endStep
          );
     
          chapter.steps = includedSteps;
          chapter.completedSteps = includedSteps?.filter(s => s?.stepStatus == 'Review')?.length;
          chapter.activeStep = includedSteps?.filter(
            s => s.stepStatus == 'Resume' || (s.step == this.scheduleDay && s.stepStatus !== 'Review')
          )?.length;
          chapter.notStartedStep = includedSteps.filter(
            s => s.step == this.scheduleDay && !s.stepStatus
          )?.length;
          chapter.totalSteps = includedSteps?.length;
        });
      }
    }
     const firstChapter = this.chaptersInfo[0]
      const lastChapter = this.chaptersInfo[this.chaptersInfo?.length - 1];
    if(this.initialChapterStepsInfo?.totalSteps>0 && (firstChapter && firstChapter?.startStep > 1) ){
     let initialChapterSteps = this.dailyStepsArray.filter(s => s.step <  firstChapter?.startStep);
      this.initialChapterStepsInfo.steps= initialChapterSteps
       this.initialChapterStepsInfo.completedSteps = initialChapterSteps.filter(s => s.stepStatus == 'Review')?.length
        this.initialChapterStepsInfo.activeStep = initialChapterSteps.filter(s => s.stepStatus == 'Resume' || (s.step==this.scheduleDay && s.stepStatus !== 'Review'))?.length
        this.initialChapterStepsInfo.notStartedStep = initialChapterSteps.filter(s =>  s.step == this.scheduleDay && !s.stepStatus)?.length

    }
    if ((( this.userShuffledChapters && this.userShuffledChapters?.chapterOrder) ||this.finalChaptertepsInfo?.totalSteps>0 )&& (lastChapter && lastChapter?.endStep < this.dailyStepsArray?.length) ) {
      let finalChapterSteps = this.dailyStepsArray.filter(s => s.step > lastChapter?.endStep);
      if (!this.finalChaptertepsInfo || this.finalChaptertepsInfo?.totalSteps == 0) {
        // this.finalChaptertepsInfo = {} as ExcludedSteps;
        let finalChapterSteps = this.dailyStepsArray.filter(s => s.step > lastChapter.endStep);
        const completedEndSteps = finalChapterSteps.filter(s => s.stepStatus == 'Review')
        const activeStep = finalChapterSteps.filter(s => s.stepStatus == 'Resume' || (s.step == this.scheduleDay && s.stepStatus !== 'Review'))
        const notStartedStep = finalChapterSteps.filter(s => s.step == this.scheduleDay && !s.stepStatus)
        this.finalChaptertepsInfo = {
          steps: finalChapterSteps,
          completedSteps: completedEndSteps?.length,
          activeStep: activeStep?.length,
          notStartedStep: notStartedStep?.length,
          totalSteps: finalChapterSteps?.length
        }
      }
      else {
        this.finalChaptertepsInfo.steps = finalChapterSteps;
        this.finalChaptertepsInfo.completedSteps = finalChapterSteps.filter(s => s.stepStatus == 'Review')?.length
        this.finalChaptertepsInfo.activeStep = finalChapterSteps.filter(s => s.stepStatus == 'Resume' || (s.step == this.scheduleDay && s.stepStatus !== 'Review'))?.length
        this.finalChaptertepsInfo.notStartedStep = finalChapterSteps.filter(s => s.step == this.scheduleDay && !s.stepStatus)?.length
      }
    }

    let time = this.isMobile ? 0 : 500
     if (this.finalChaptertepsInfo?.totalSteps>0 || this.initialChapterStepsInfo?.totalSteps>0 ||this.finalSortedChaptersInfo?.length > 0) {
     setTimeout(async () => {
        await this.swipeToActiveSlide(100); 
      },time);
    }
    this.expandCardForSteps();
    this.expandCardGetStarted();
    this.expandCardFinishStarted();
  }
  
  fetchChaptersSteps() {
    let onboardingStepsData =this.dailyStepsArray
  .map(step => step.onboardingSteps)
  .filter(s => s != null && (Array.isArray(s) ? s?.length > 0 : true))
  .flatMap(s => Array.isArray(s) ? s : [s]);
    if (onboardingStepsData?.length>0) {
       this.pathPersonalizationScreeInfo = onboardingStepsData.filter(s=>s.stepTypes == 'pathPersonalization')
    }
     if (this.chaptersInfo?.length > 0) {
    // //  Reorder chapters as per chapterorder , neeed to uncomment when working on reoder chapters flow
      if (this.userShuffledChapters && this.userShuffledChapters?.chapterOrder) {
        // Find chapters NOT in order list
        const missingChapters = this.chaptersInfo.filter(c => !this.userShuffledChapters.chapterOrder.includes(c.id));

        const orderedChapters = this.userShuffledChapters?.chapterOrder
          .map(id => this.chaptersInfo.find(c => c.id === id))
          .filter(Boolean); // remove undefined if any

        // Final reordered chapters (missing first, then ordered ones)
        this.finalSortedChaptersInfo = [...missingChapters, ...orderedChapters];
      }
      else {
        if (this.pathPersonalizationScreeInfo?.length > 0) {
          this.finalSortedChaptersInfo = this.chaptersInfo.filter(chapter => {
            // Include only chapters until path personalisation is present
            return chapter.startStep <= this.pathPersonalizationScreeInfo[0]?.startDay;
          });
          if(this.chaptersInfo?.length -this.finalSortedChaptersInfo?.length ==1) {
            this.finalSortedChaptersInfo = this.chaptersInfo;
          }
        }
        else {
          this.finalSortedChaptersInfo = this.chaptersInfo;
        }
     }
      // Skip previous chapters if pathpersonnalization screen exists in other than get started chapter
      console.log("pathPersonalizationScreeInfo pathPersonalizationScreeInfo", this.pathPersonalizationScreeInfo)

      // Get first and last chapters before reorder
      const firstChapter = this.chaptersInfo[0]
      const lastChapter = this.chaptersInfo[this.chaptersInfo?.length - 1];
      this.scheduleDay = this.appState.get('scheduleDayForCurrentStep')
      if (firstChapter && firstChapter?.startStep > 1) {
        let initialChapterSteps = this.dailyStepsArray.filter(s => s.step < firstChapter.startStep);
        const completedStartSteps = initialChapterSteps.filter(s => s.stepStatus == 'Review')
        const activeStep = initialChapterSteps.filter(s => s.stepStatus == 'Resume' || (s.step==this.scheduleDay && s.stepStatus !== 'Review'))
        const notStartedStep = initialChapterSteps.filter(s =>  s.step == this.scheduleDay && !s.stepStatus)
        this.initialChapterStepsInfo = {
          steps: initialChapterSteps,
          completedSteps: completedStartSteps?.length,
          activeStep: activeStep?.length,
          notStartedStep: notStartedStep?.length,
          totalSteps:initialChapterSteps?.length
        }
      }

      if (lastChapter && lastChapter?.endStep < this.dailyStepsArray?.length && ((this.userShuffledChapters && this.userShuffledChapters?.chapterOrder) || ( this.pathPersonalizationScreeInfo?.length<=0))) {
        let finalChapterSteps = this.dailyStepsArray.filter(s => s.step > lastChapter.endStep);
        const completedEndSteps = finalChapterSteps.filter(s => s.stepStatus == 'Review')
         const activeStep= finalChapterSteps.filter(s=>s.stepStatus=='Resume'|| (s.step==this.scheduleDay && s.stepStatus !== 'Review'))
         const notStartedStep = finalChapterSteps.filter(s =>  s.step == this.scheduleDay && !s.stepStatus)
        this.finalChaptertepsInfo = {
          steps: finalChapterSteps,
          completedSteps: completedEndSteps?.length,
           activeStep: activeStep?.length,
          notStartedStep: notStartedStep?.length,
          totalSteps:finalChapterSteps?.length
        }
      }
      // Attach steps for each chapter based on start_step & end_step
       if (this.userShuffledChapters && this.userShuffledChapters?.chapterOrder) {
         let startIndex=0;
         let endIndex =this.initialChapterStepsInfo?.totalSteps>0?this.initialChapterStepsInfo?.totalSteps:0 ;
         this.finalSortedChaptersInfo = this.finalSortedChaptersInfo.map(chapter => {
           startIndex = endIndex + 1
           endIndex = startIndex+ (chapter.endStep - chapter.startStep)
          //  const includedSteps = this.dailyStepsArray.filter(
             
          //    s => s.step >= startIndex && s.step <= endIndex
          //  );
          const includedSteps = this.dailyStepsArray
             .filter(s => s.originalStep >= chapter.startStep && s.originalStep <= chapter.endStep)
             .sort((a, b) => a.originalStep - b.originalStep);
           const completedStepsLength = includedSteps.filter(s => s.stepStatus == 'Review')
           const activeStep = includedSteps.filter(s => s.stepStatus == 'Resume' || (s.step == this.scheduleDay && s.stepStatus !== 'Review'))
           const notStartedStep = includedSteps.filter(s => s.step == this.scheduleDay && !s.stepStatus)
           return { ...chapter, steps: includedSteps, completedSteps: completedStepsLength?.length, activeStep: activeStep?.length, notStartedStep: notStartedStep?.length, totalSteps: includedSteps?.length };
         });
       }
       else if(this.finalSortedChaptersInfo?.length>0){
          this.finalSortedChaptersInfo = this.finalSortedChaptersInfo.map(chapter => {
        const includedSteps = this.dailyStepsArray.filter(
          s => s.step >= chapter.startStep && s.step <= chapter.endStep
        );
        const completedStepsLength = includedSteps.filter(s => s.stepStatus == 'Review')
        const activeStep= includedSteps.filter(s=>s.stepStatus=='Resume'|| (s.step==this.scheduleDay && s.stepStatus !== 'Review'))
        const notStartedStep = includedSteps.filter(s =>  s.step == this.scheduleDay && !s.stepStatus)
        return { ...chapter, steps: includedSteps, completedSteps: completedStepsLength?.length, activeStep: activeStep?.length, notStartedStep: notStartedStep?.length, totalSteps: includedSteps?.length };
      });
       }
      let time = this.isMobile ?0 : 500
     setTimeout(async () => {
        await this.swipeToActiveSlide(100); 
      },time);
      console.log(this.finalSortedChaptersInfo);
     }
    this.expandCardForSteps();
    this.expandCardGetStarted();
    this.expandCardFinishStarted();
  }

  expandCorrectChapter() {
    if(this.expandedIndex) {
      let middleChapterIndex= this.finalSortedChaptersInfo.findIndex((chapter)=>this.scheduleDay >= chapter.startStep && this.scheduleDay <= chapter.endStep)
      if (middleChapterIndex != -1) {
        this.isExpandedCard1 = false;
         this.isExpandedCard2 = false;
         this.expandedIndex = middleChapterIndex;
      }

    }

    if(this.isExpandedCard1 && this.initialChapterStepsInfo?.steps?.length>0) 
    {
      let initialStep = this.initialChapterStepsInfo?.steps[0].step
      let intialChapterIndex = this.initialChapterStepsInfo?.steps?.findIndex((step) => this.scheduleDay<=initialStep && this.scheduleDay <= step.step)
       if (intialChapterIndex != -1) {
         this.isExpandedCard1 = true;
         this.isExpandedCard2 = false;
         this.expandedIndex = null;
      }
    }
     if(this.isExpandedCard2 && this.finalChaptertepsInfo?.steps?.length>0) 
     {
        let initialStep = this.finalChaptertepsInfo?.steps[0].step
      let finalChapterIndex = this.finalChaptertepsInfo?.steps?.findIndex((step) => this.scheduleDay<=initialStep &&this.scheduleDay <= step.step)
       if (finalChapterIndex != -1) {
       this.isExpandedCard1 = false;
         this.isExpandedCard2 = true;
         this.expandedIndex = null;
      }
    }
  }
  progressBarGradient(chapterInfo) {
    let totSteps = chapterInfo?.totalSteps;
    let currentStep =
      chapterInfo?.completedSteps === 0 && chapterInfo?.activeStep === chapterInfo?.notStartedStep
        ? 0
        : chapterInfo?.completedSteps > 0
          ? chapterInfo?.completedSteps + (chapterInfo?.activeStep === chapterInfo?.notStartedStep ? 0 : chapterInfo?.activeStep / 2)
          : chapterInfo?.activeStep / 2;
    const stepSize = 100 / totSteps;
    const stepPercentage = stepSize * currentStep;
    const completedStepGradient = `${stepPercentage}%`;
    return completedStepGradient;
  }
  progressStepBarGradient(currentStep) {
    let data = this.appState.get("screensViewed")
    if (!data || data == undefined) {
      if (this.appState.get('pathRegistration')) {
        data = this.appState.get('pathRegistration')?.screensViewed
      }
      else {
        return 0;
      }
    }
    let stepObjects
    if (data) {
      stepObjects = data.filter(item => item.step === currentStep?.step);
    }
    if (stepObjects?.length === 0 || !data) return 0;

    // take the last one
    const lastStep = stepObjects[stepObjects?.length - 1];
    // const stepPercentage = currentStep?.stepStatus=='Resume'&& currentStep?.step==this.scheduleDay?'50':currentStep?.stepStatus=='Review'?'100':0
    const stepPercentage = (lastStep?.visitedScreens / lastStep?.totalScreens) * 100;
    const completedStepGradient = `${stepPercentage}%`;
    return completedStepGradient;
  }

  toggleCard(index: number) {
    let time = this.isMobile ? 0 : 500;
    this.expandedIndex = this.expandedIndex === index ? null : index;
      // this.swipeToActiveSlide(time, 'middleChapter')
  }


  toggleCardSingle(card: 'card1' | 'card2') {
    let time = this.isMobile ? 0 : 500;
    if (card === 'card1') {
      this.isExpandedCard1 = !this.isExpandedCard1;
    } else if (card === 'card2') {
      this.isExpandedCard2 = !this.isExpandedCard2;
      this.swipeToActiveSlide(time, 'endChapter')
    }
  }

  async getStepArrayInfo(){
    let stepBegin= false;
    this.dailyStepsArray?.forEach((step)=>{
     if(step?.stepStatus =='Review' && step?.step < this.dailyStepsArray?.length )
     {
       this.appState.set("currentScheduleDay",step?.step+1)
       this.appState.set('scheduleDayForCurrentStep',  step?.step+1);
       stepBegin =true;
     }
     else if(step?.stepStatus=='Resume') {
       this.appState.set("currentScheduleDay",step?.step)
       this.appState.set('scheduleDayForCurrentStep',  step?.step);
       stepBegin =true
     }
     else if(!step?.stepStatus && !stepBegin) {
       this.appState.set("currentScheduleDay",step?.step)
       this.appState.set('scheduleDayForCurrentStep',  step?.step);
       stepBegin =true
     }
    })
    this.updateChpaterStepStatus();
    let time=this.isMobile?0:500
  //  setTimeout(async ()=>{
  //    await this.swipeToActiveSlide(200); 
  //   },time);
  }

  isAllItemsVisible() {
    const slidesPerView = +this.swiper.params.slidesPerView;
    const totalSlides = this.swiper.slides.length;
    const activeIndex = this.swiper.activeIndex;
    return activeIndex + slidesPerView >= totalSlides;
  }

expandCardForSteps(): void {
  if (!this.finalSortedChaptersInfo || this.finalSortedChaptersInfo.length === 0) {
    return;
  }
  for (let i = 0; i < this.finalSortedChaptersInfo.length; i++) {
    const chapter = this.finalSortedChaptersInfo[i];  
    if (!chapter || !Array.isArray(chapter.steps)) {
      continue;
    }
    const hasResumeStep = chapter.steps.some(step =>
      step?.stepStatus == 'Resume' || (step.step == this.scheduleDay && step.stepStatus !== 'Review')
    );
    if (hasResumeStep) {
      this.expandedIndex = i;
      break;
    }
    else {
      this.expandedIndex = null
    }
  }
}

expandCardGetStarted(): void {
  if (!this.initialChapterStepsInfo?.steps) return;
  const hasResumeStep = this.initialChapterStepsInfo.steps.some(
    step => step?.stepStatus == 'Resume' || (step.step == this.scheduleDay && step.stepStatus !== 'Review')
  );
  if (hasResumeStep) {
    this.isExpandedCard1 = true;
  }
  else {
    this.isExpandedCard1 = false;
  }
}
expandCardFinishStarted(): void {
  if (!this.finalChaptertepsInfo?.steps) return;
  const hasResumeStep = this.finalChaptertepsInfo.steps.some(
    step => step?.stepStatus == 'Resume' || (step.step == this.scheduleDay && step.stepStatus !== 'Review')
  );
  if (hasResumeStep) {
    this.isExpandedCard2 = true;
  }
  else 
  {
    this.isExpandedCard2 = false; 
  }
}

  ngDoCheck(): void {
    // this.dailyStepsArray= this.appState.get("DailyStepsData");
    this.allPathsCount = this.appState.get('allPathCount')
    this.userShuffledChapters = this.appState.get('userShuffledChapters');
    this.scheduleDay = this.appState.get("scheduleDayForCurrentStep")
    this.currentDay = this.appState.get('currentScheduleDay')
    this.path = this.appState.get('currentPath');
  }

  scrollToMiddleChaptersStep() {
    let flatIndex = 0;
    for (let chapter of this.finalSortedChaptersInfo) {
      for (let step of chapter.steps) {
        const shouldScroll =
          chapter.activeStep > 0 &&
          (step.step === this.scheduleDay || step.stepStatus === 'Resume');
        if (shouldScroll) {
          const card = this.stepCards.toArray()[flatIndex];
          if (card && card?.nativeElement && this.isMobile) {
            this.content.scrollToPoint(
              0,
              //  card.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
              card.nativeElement.offsetTop + 20
           )
          }
          else if (card && card?.nativeElement && !this.isMobile) {
            
            const elementRect = card?.nativeElement?.getBoundingClientRect();
            const parentContainer = this.scrollContainer?.nativeElement?.getBoundingClientRect();
            const offsetTop = elementRect?.top - parentContainer?.top + this.scrollContainer?.nativeElement?.scrollTop - 20;
            this.scrollContainer?.nativeElement?.scrollTo({
              top: offsetTop,
              behavior: 'smooth', 
            })
          }
          // return;
        //}
      }
      flatIndex++;
    }
  }
  }
   scrollTofinalChaptersStep() {
    let flatIndex = 0;
    if(this.finalChaptertepsInfo?.totalSteps>0) {
      //for (let step of chapter.steps) {
      this.finalChaptertepsInfo?.steps.forEach((step) => {
        const shouldScroll =
          this.finalChaptertepsInfo?.activeStep > 0 &&
          (step.step === this.scheduleDay || step.stepStatus === 'Resume');
        if (shouldScroll) {
          const card = this.finishStepCards?.toArray()[flatIndex];
          // if (card && card?.nativeElement) {
          //   this.content.scrollToPoint(
          //     0,
          //     card.nativeElement.offsetTop + 20
          //   )
          // }
          if (card && card?.nativeElement && this.isMobile) {
            this.content.scrollToPoint(
              0,
              //  card.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
              card.nativeElement.offsetTop + 20
           )
          }
          else if (card && card?.nativeElement && !this.isMobile) {
            
            const elementRect = card?.nativeElement?.getBoundingClientRect();
            const parentContainer = this.scrollContainer?.nativeElement?.getBoundingClientRect();
            const offsetTop = elementRect?.top - parentContainer?.top + this.scrollContainer?.nativeElement?.scrollTop - 20;
            this.scrollContainer?.nativeElement?.scrollTo({
              top: offsetTop,
              behavior: 'smooth', 
            })
          }
          // return;
          //}
        }
        flatIndex++;
      });
  }
  }
  async swipeToActiveSlide(time, val=null) {
     let chapterId = this.finalSortedChaptersInfo.findIndex((chapter) => chapter?.activeStep>0)
    if (this.isMobile) {
      setTimeout(() => {
         if (((this.finalChaptertepsInfo?.activeStep > 0 && val != 'middleChapter')|| this.dailyStepsArray[this.dailyStepsArray?.length-1]?.stepStatus=='Review'|| val=='endChapter') && this.focusableEndChapter && this.focusableEndChapter?.nativeElement) {
           if (!val || val != 'middleChapter' || val=='endChapter') {
            //  this.content.scrollToPoint(
            //    0,
            //    this.focusableEndChapter.nativeElement.offsetTop - 50, // small padding
            //    100
             //  );
             setTimeout(() => {
              this.scrollTofinalChaptersStep();
            }, 200);
             return;
           }
        }
        if (this.expandedIndex >= 0 && this.chapterCards && ((chapterId!=-1&& val!=='endChapter')|| val == 'middleChapter' || (this.dailyStepsArray[this.dailyStepsArray?.length-1]?.stepStatus=='Review' && !this.finalChaptertepsInfo?.totalSteps))) {
         let card
          if (val == 'middleChapter') {
            card = this.chapterCards.toArray()[this.expandedIndex];
          }
          else {
           card = this.chapterCards.toArray()[chapterId!=-1?chapterId:this.finalSortedChaptersInfo?.length-1];
          }
          console.log("this.chapterCards.toArray()",this.chapterCards.toArray(), this.scheduleDay,chapterId)
          if (card && card?.nativeElement) {
            // this.content.scrollToPoint(
            //   0,
            //   card.nativeElement.offsetTop - 50
            // );
            setTimeout(() => {
            this.scrollToMiddleChaptersStep();
          }, 200);
          }
        }
      }, 150);
    }
    else {
     
      setTimeout(() => {
        let focusableElement;
        if (((this.finalChaptertepsInfo?.activeStep > 0 && val != 'middleChapter')|| this.dailyStepsArray[this.dailyStepsArray?.length - 1]?.stepStatus == 'Review'|| val=='endChapter') && this.focusableEndChapter && this.focusableEndChapter?.nativeElement) {
          if (!val || val != 'middleChapter' || val=='endChapter') {
            focusableElement = this.focusableEndChapter
          }
        }
        if (this.expandedIndex >= 0 && this.chapterCards && ((chapterId!=-1 && val!=='endChapter') || val == 'middleChapter'|| (this.dailyStepsArray[this.dailyStepsArray?.length-1]?.stepStatus=='Review'&& !this.finalChaptertepsInfo?.totalSteps))) {
          if (val == 'middleChapter') {
            const card = this.chapterCards.toArray()[this.expandedIndex];
          if (card && card?.nativeElement) {
            focusableElement = card
          }
          }
          else {
            const card = this.chapterCards.toArray()[chapterId != -1 ? chapterId : this.finalSortedChaptersInfo?.length - 1];
            if (card && card?.nativeElement) {
              focusableElement = card
            }
          }
        }
        if (focusableElement?.nativeElement) {
          const elementRect = focusableElement?.nativeElement?.getBoundingClientRect();
          const parentContainer = this.scrollContainer?.nativeElement?.getBoundingClientRect();
          // Get position relative to scrollContainer
          const offsetTop = elementRect?.top - parentContainer?.top + this.scrollContainer?.nativeElement?.scrollTop -50;
          // this.scrollContainer?.nativeElement?.scrollTo({
          //   top: offsetTop,
          //   behavior: 'smooth', // Smooth scrolling effect
          // })
          if (this.expandedIndex >= 0 && this.chapterCards && ((chapterId != -1 && val !== 'endChapter') || val == 'middleChapter' || (this.dailyStepsArray[this.dailyStepsArray?.length - 1]?.stepStatus == 'Review' && !this.finalChaptertepsInfo?.totalSteps))) {

            setTimeout(() => {
              this.scrollToMiddleChaptersStep();
            }, 300);
          }
          if (((this.finalChaptertepsInfo?.activeStep > 0 && val != 'middleChapter') || this.dailyStepsArray[this.dailyStepsArray?.length - 1]?.stepStatus == 'Review' || val == 'endChapter') && this.focusableEndChapter && this.focusableEndChapter?.nativeElement) {

            setTimeout(() => {
              this.scrollTofinalChaptersStep();
            }, 300);
          }
          
        }
      
      }, time);
    }
  }
  ngAfterViewInit() {
    this.homeUIService.expandOnEnterAnimation()
    setTimeout(() => {
      const content = this.contentWrapper?.nativeElement;
      this.isScrollbarPresent = content?.scrollHeight > this.content['el']?.scrollHeight;
      this.checkScrollbar();
    }, 700);
  }
  
  closePage() {
    this.homeUIService.getLastModal();
    this.modalController.dismiss();
  }
  changeSubTextFont(stepTitle,index) {
   if(stepTitle) {
     // const element = stepTitle?.toArray()[index]?.nativeElement;
     const element = stepTitle?.el
    const specificElement = element?.querySelector('p') || element?.querySelector('h1') || element?.querySelector('h2');
    if(specificElement) {
      this.render.setStyle(specificElement, 'font-size', '20px');
      this.render.setStyle(specificElement, 'font-weight', '500');
      this.render.setStyle(specificElement, 'font-style', 'normal');
      this.render.setStyle(specificElement, 'line-height', '23.44px');
      this.render.setStyle(specificElement, 'font-family', 'Roboto');
     this.render.setStyle(specificElement, 'word-break', 'break-word');
     this.render.setStyle(specificElement, 'overflow', 'hidden');
     this.render.setStyle(specificElement, ' text-overflow', 'ellipsis');
     this.render.setStyle(specificElement, 'display', '-webkit-box');
     this.render.setStyle(specificElement, '-webkit-line-clamp', '2');
     this.render.setStyle(specificElement, 'margin-bottom', '8px');
     this.render.setStyle(specificElement, '-webkit-box-orient', 'vertical');

    }
  return true;
   }
   
  }

  goToStep(inout) {
    if (this.currentDay >= inout.startDay) {
      this.homeUIService.dismissAllModals().then(() => {
        if(this.currentDay !== inout.startDay){
          const pathProgress = localStorage.getItem(
            `PathProgress:User:${this.currentUser.id}:DayProgress:${this.path.id}:${inout.startDay}`
          )
          this.appState.set('screenId',pathProgress)
        }
        this.appState.set('isYourPathPrevious', true);
        this.router.navigate(['/content', inout.startDay]);
      });
    }
  }

  openToDoListModal(btn?) {
    if (this.sessionService.isTabletDevice() && btn=='to-do') {
      this.focusPlayBtn();
      setTimeout(() => {
        this.buttonOnBlur();
      }, 1000);
    }
    this.homeUIService.openNextComponent(MyCommitmentsComponent,'','desktop-todo')
  }
  openAllPathsComponent() {
    this.appState.set("isAllPaths", true);
    this.homeUIService.openNextComponent(AllPathsComponent,'','desktop-allpath')
  }

  async openDailyStepsModal(comp?, compProps?,className?){
    if(this.homeUIService?.isDark()){
      const cust_class = className?className:'custom-modal'
      className = 'web-daily-steps-custom-modal dark-theme'
      }else{
        className = className?className:'custom-modal'
      }
      console.log("className", className);
    if(comp) {
      const modal = await this.modalController.create({
        component: comp,
        componentProps: compProps,
        // animated: false,
        cssClass: className,
        enterAnimation: this.animationService.slideInUpEnterAnimation,
        leaveAnimation: this.animationService.slideOutDownLeaveAnimation
       
      });
       await modal.present() 
      modal.onWillDismiss().then((data) => {
        if(data?.data?.isOpenNextStep) {
          modal.animated =false
         }
         if(data?.data?.isInstepTodoScreen) {
          this.homeUIService.unlockNextHabitLevel();
         }
         if (data?.data?.nextHabitUnlockFromToDoScreen == 'nextHabitUnlockFromToDoScreen') {
           setTimeout(() => {
             this.openDailyStepsModal(DailyStepsContentModalComponent, { currentDay: data?.data?.currentDay, startFromScreen: 'daily-content-screen-todo' }, 'web-daily-steps-custom-modal');
           }, 600);
         }
        if (data?.data?.isAlertUnlockClosed) {
           this.appState.set('isLevelClosedBeforeCommit', true)
            this.openDailyStepsModal(DailyStepsContentModalComponent,{currentDay: data?.data?.currentDay,startFromScreen: 'daily-content-screen-routine-sub-level'},'web-daily-steps-custom-modal')
         }
        
        if(this.dailyStepsArray[this.currentDay-1]?.stepStatus!=='Review'){
          this.getStepArrayInfo();
        }
       });
      modal.onDidDismiss().then(() => {
         this.isModalOpen = false;
      })
     
    }
   
   }

  findCurrentPlatform(){
    const ua = navigator.userAgent.toLowerCase();
    const hasTouch = navigator.maxTouchPoints > 1 || 'ontouchstart' in window;

    // Actual tablets (Android Tablets, iPads)
    const isTablet = /ipad|android(?!.*mobi)|tablet/i.test(ua);

    // Exclude touch laptops (Windows/macOS laptops with touchscreens)
    let  isLaptop = hasTouch && !isTablet && /windows|mac os|linux/i.test(ua);
    console.log("is tablet and isLaptop", isTablet, isLaptop)
    if(this.platform.is("mobileweb") && this.platform.is("ipad")&& (!isLaptop || !this.platform.is('desktop'))){
      return 'web-ipad';
    } else if(this.platform.is("mobileweb") && this.platform.is("tablet")&& (!isLaptop || !this.platform.is('desktop'))){
      return 'web-tablet';
    } else if(this.platform.is("mobileweb") && this.platform.is("ios") && !this.platform.is("ipad")){
      return 'web-ios';
    } else if(this.platform.is("mobileweb") && this.platform.is("android") && !this.platform.is("tablet")){
      return 'web-android';
    } else if(this.platform.is("ios") && this.platform.is("mobile")){
      return 'ios';
    } else if(this.platform.is("android") && this.platform.is("mobile")){
      return 'android';
    } else if(!this.isMobile){
      return 'web';
    }
  }

  openDailyStepContent(stepData,btn?) {
    let dailyStepsArray = this.appState.get('DailyStepsData');
     if (stepData?.step !== 1 && (stepData?.step > this.scheduleDay && !dailyStepsArray[stepData?.step-1]?.stepStatus)) {
         this.isModalOpen =false
        // this.toasterService.warning(this.i18n.t("Please complete previous step"));
        return
      }
    if (this.sessionService.isTabletDevice() && btn == "playBtn") {
      this.focusPlayBtn();
      setTimeout(() => {
        this.buttonOnBlur();
      }, 1000);
    }
    if (this.isModalOpen) {
      return
    }
    this.isModalOpen = true;
    this.appState.set("allowScreenCount", true);
    this.appState.set("currentScheduleDay",stepData?.step)
    if(stepData.stepStatus =="Review"){
      this.replay(stepData?.step)
    }
    else if (stepData.stepStatus == "Resume") {
       this.appState.set("screenStatus", 2);
      this.openDailyStepsModal(DailyStepsContentModalComponent,{currentDay: stepData?.step},'web-daily-steps-custom-modal')
      // this.router.navigate(['/content', stepData?.step])
    }else{
      var i = stepData?.step - 1;
      if (stepData?.step !== 1 && (stepData?.step != this.scheduleDay || stepData?.step > this.scheduleDay )) {
        // this.toasterService.warning(this.i18n.t("Please complete previous step"));
         this.isModalOpen =false
        return
      }
       //commenting 668 frontend change
      const reqData = {
        user_id: this.currentUser.id,
        path_id: this.path.id,
        step: stepData?.step,
        platform: this.findCurrentPlatform(),
        original_step: dailyStepsArray[stepData?.step-1]?.originalStep
      };
      this.routineService.startTime(reqData).subscribe( (response) => {
        console.log('post request succesful', response);
      }, (error) => {
        console.log('Error: ', error);
        this.toasterService.warning("Error, please check!");
      });
    
      if (i == 0) {
        if(!this.isMobile) {
          // this.router.navigate(['/content', stepData?.step])
          localStorage.setItem('isBeginClicked','true')
          this.openDailyStepsModal(DailyStepsContentModalComponent,{currentDay: stepData?.step},'web-daily-steps-custom-modal')

        }
        return;
      }
       let updateScheduleDay = i + 1;
      let data = {
        schedule_day: updateScheduleDay,
        user_id: this.currentUser.id,
      };
      // if (previousDayCompleted) {
        this.homev5Service.updateScheduleDay(data).subscribe(
          (response) => {
            if (response.success == true) {
              localStorage.setItem('isBeginClicked','true')
              this.appState.set("allowScreenCount", true);
              this.appState.set("LevelNumber", 1);
              this.appState.set("maxAllowedScheduleDay", updateScheduleDay);
              this.appState.set("currentScheduleDay", updateScheduleDay);
              this.appState.set("scheduleDayForCurrentStep", updateScheduleDay);
              this.appState.set("indexOfLevel", 0);
              this.appState.set("levelUpdated", undefined);
              this.currentDay = this.appState.get("currentScheduleDay"); // LUMBA-1379
              this.scheduleDay = this.appState.get("scheduleDayForCurrentStep");
              localStorage.removeItem(
                `Toggle:User:${this.currentUser.id}:DayProgress:${this.path.id}:${
                  !(i == undefined) ? i + 1 : stepData?.step
                }`
              );

              this.openDailyStepsModal(DailyStepsContentModalComponent,{currentDay:  !(i == undefined) ? i + 1 : stepData?.step},'web-daily-steps-custom-modal')

              return false;
            } else {
              this.toasterService.warning(this.i18n.t(
                "Server or connection issue. Please check your internet connection."
              ));
            }
          },
          (error) => {
            this.toasterService.warning(this.i18n.t(
              "Server or connection issue. Please check your internet connection."
            ));
            console.log("Response of update  error", error);
          }
        );
      // } else {
      //   this.toasterService.warning(this.i18n.t("Please complete previous step"));
      // }
    }

  }

  unlockReplay(stepData) {
    let index= stepData?.step;
    let dailyStepsArray = this.appState.get('DailyStepsData');
    if (stepData?.step !== 1 && (stepData?.step > this.scheduleDay && !dailyStepsArray[stepData?.step-1]?.stepStatus)) {
         this.isModalOpen =false
        // this.toasterService.warning(this.i18n.t("Please complete previous step"));
        return
      }
    this.appState.set("currentScheduleDay", index);
    this.appState.set("allowScreenCount", true);
    if(stepData?.stepStatus =='Review'){
      this.replay(stepData?.step)
    }
    else if(stepData?.stepStatus =='Resume'){
      this.router.navigate(['/content', index])
    } else {
       if (index !== 1 && (index != this.scheduleDay || index > this.scheduleDay )) {
        // this.toasterService.warning(this.i18n.t("Please complete previous step"));
        this.isModalOpen =false
         return
      }
       const reqData = {
        user_id: this.currentUser.id,
        path_id: this.path.id,
        step: stepData?.step,
        platform: this.findCurrentPlatform(),
        original_step: dailyStepsArray[stepData?.step - 1]?.originalStep
      };
      this.routineService.startTime(reqData).subscribe( (response) => {
        console.log('post request succesful', response);
      }, (error) => {
        console.log('Error: ', error);
        this.toasterService.warning("Error, please check!");
      });
      var i = index - 1;
      if (i == 0) {
        localStorage.setItem('isBeginClicked','true')
        this.router.navigate(['/content', index])
        return;
      }
      let previousDayCompleted;
      let updateScheduleDay = i + 1;
      for (let s = index - 1; s >= 0; s--) {
        let dayHasContent = this.path.checkContentForDay(s);
        if (dayHasContent) {
          previousDayCompleted = this.homev5Service.checkPrevDayCompleted(
            this.pathRegistration,
            s,
            this.currentUser,
            this.path
          )
          break;
        }
      }
      let data = {
        schedule_day: updateScheduleDay,
        user_id: this.currentUser.id,
      };
       if (previousDayCompleted || index<=this.scheduleDay) {
        this.homev5Service.updateScheduleDay(data).subscribe(
          (response) => {
            if (response.success == true) {
              localStorage.setItem('isBeginClicked','true')
              this.appState.set("allowScreenCount", true);
              this.appState.set("LevelNumber", 1);
              this.appState.set("maxAllowedScheduleDay", updateScheduleDay);
              this.appState.set("currentScheduleDay", updateScheduleDay);
              this.appState.set("scheduleDayForCurrentStep", updateScheduleDay);
              this.appState.set("indexOfLevel", 0);
              this.appState.set("levelUpdated", undefined);
              this.currentDay = this.appState.get("currentScheduleDay"); // LUMBA-1379
              this.scheduleDay = this.appState.get("scheduleDayForCurrentStep");
              localStorage.removeItem(
                `Toggle:User:${this.currentUser.id}:DayProgress:${this.path.id}:${
                  !(i == undefined) ? i + 1 : this.scheduleDay
                }`
              );
              this.router.navigate([
                "/content",
                !(i == undefined) ? i + 1 : this.scheduleDay,
              ]);

              return false;
            } else {
              this.toasterService.warning(this.i18n.t(
                "Server or connection issue. Please check your internet connection."
              ));
            }
          },
          (error) => {
            this.toasterService.warning(this.i18n.t(
              "Server or connection issue. Please check your internet connection."
            ));
            console.log("Response of update  error", error);
          }
        );
       } 
      else {
        this.toasterService.warning(this.i18n.t("Complete the previous step to unlock this step."));
      }
    }
    
  }

  replay(i) {
    this.appState.set("isNewStepUnlocked", undefined);
    let screensViewed = this.appState.get('screensViewed')
    this.appState.set('allowScreenCount', undefined)
    let stepsArray;
    if (this.pathRegistration?.screensViewed) {
      stepsArray = this.homev5Service.removeDuplicates(this.pathRegistration?.screensViewed,"step");
    }else{
      stepsArray = screensViewed
    }
    stepsArray?.forEach((element) => {
      if (
        element?.step == this.scheduleDay &&
        element?.visitedScreens === element?.totalScreens
      ) {
      }
    });    

    localStorage.removeItem(
      `Toggle:User:${this.currentUser.id}:DayProgress:${this.path.id}:${
        i
      }`
    );
    if (this.isMobile) {
       this.isModalOpen = false;
      this.router.navigate([
        "/content",
        !(i == undefined) ? i : this.scheduleDay,
      ]);
    }
   else {
    this.openDailyStepsModal(DailyStepsContentModalComponent,{currentDay:i },'web-daily-steps-custom-modal')
   }
    return false;
  }
  loadSvgFile(path,pos?) {
    this.http.get(path, { responseType: 'text' })
      .subscribe(svgData => {
        const parser = new DOMParser();
        const svgDoc = parser.parseFromString(svgData, 'image/svg+xml');
        const primaryColor = getComputedStyle(document?.documentElement)?.getPropertyValue('--theme-color');
        let pathElements = svgDoc.querySelectorAll('stop');
       pathElements?.forEach(pathElement => {
        const currentColor = pathElement?.getAttribute('stop-color')
        if(pathElement?.getAttribute('stop-color')=='#8077E7'){
          pathElement?.setAttribute('stop-color', primaryColor); // Use the var(--color) notation to set the fill color dynamically         
        }
      
      });   
      const serializer = new XMLSerializer();
      const modifiedSvgData = serializer.serializeToString(svgDoc);
      const encodedData = encodeURIComponent(modifiedSvgData);
      if(path =='../../../assets/web_home_ui/white_circular_to-do.svg') {
        this.onFocuseCloseOut =`data:image/svg+xml,${encodedData}`;
      }
      if(path =='../../../assets/web_home_ui/black_circular-to-do.svg') {
        this.closeoutSvg =`data:image/svg+xml,${encodedData}`;
        this.startCloseout = this.closeoutSvg;
      }
      if (path == '../../../assets/web_home_ui/blur-play-btn.svg') {
        this.blurPlayButton = `data:image/svg+xml,${encodedData}`;
      }
      if(path =='../../../assets/web_home_ui/white_play_btn.svg') {
        this.onFocusPlayBtn =`data:image/svg+xml,${encodedData}`;
      } 
      else if(path =='../../../assets/web_home_ui/black_play_btn.svg'){
        this.startPlayButton =`data:image/svg+xml,${encodedData}`;
        this.playSvg =this.startPlayButton;
      }   
      });
  }
  focusPlayBtn()
  {
        console.log("entered focus method");
    this.isBtnFocused =true;
    if(this.dailyStepsArray[this.dailyStepsArray?.length-1]?.stepStatus=='Review') {
      this.closeoutSvg = this.onFocuseCloseOut
    }
    else {
      this.playSvg =this.onFocusPlayBtn;
    }
  }
  buttonOnFocus(val) {
    if (!this.sessionService.isTabletDevice()) {
      if (this.dailyStepsArray[this.dailyStepsArray?.length - 1]?.stepStatus == 'Review') {
        if (val == false) {
          this.closeoutSvg = this.startCloseout
        }
        else {
          this.closeoutSvg = this.onFocuseCloseOut
        }
      }
      else {
        if (val == false && ! this.isHovered) {
          this.playSvg = this.startPlayButton
        }
        else if (val == false && this.isHovered) {
          this.playSvg = this.blurPlayButton
        }
        else {
          this.playSvg =this.onFocusPlayBtn;
        }
      }
    }
  }
  contentOnFocus(val) {
    this.isHovered = val;
    this.buttonOnFocus(false);
  }
  openStepModal() {
    if (this.dailyStepsArray?.length > 0 && this.dailyStepsArray[this.dailyStepsArray?.length - 1]?.stepStatus != 'Review') {
      this.openDailyStepContent(this.dailyStepsArray[this.scheduleDay-1],'playBtn')
    }
    else if (this.dailyStepsArray?.length > 0 && this.dailyStepsArray[this.dailyStepsArray?.length - 1]?.stepStatus == 'Review') {
      this.openToDoListModal('to-do');
    }
  }
  buttonOnBlur() {
    console.log("entered blur method");
    if(this.dailyStepsArray[this.dailyStepsArray?.length-1]?.stepStatus=='Review') {
        this.closeoutSvg = this.startCloseout
    }
    else {
        this.playSvg = this.startPlayButton
     
    }
    this.isHovered = false;
  }
    
  onLeftSliderEnter() {
    if (this.sessionService.isTabletDevice()) {
      this.focusYourPath = false;
    } else {
      this.focusYourPath = true;
    }
  }

  onLeftSliderLeave() {
    this.focusYourPath =false
  }
  onScroll(event) {
    // Check for scrollbar presence during scrolling
    this.checkScrollbar(event);
  }

  private checkScrollbar(ev?) {
    const content = this.contentWrapper?.nativeElement;
    this.isScrollbarPresent = content?.scrollHeight > this.content['el']?.scrollHeight;
    const button = this.el?.nativeElement?.querySelector('#fixedButton');
    const divEle = document.getElementsByClassName('home-step-content-wrap');
    // if (divEle && ev) {
    //   divEle[0].setAttribute('style', 'height:auto !important;align-items:center; justify-content:center;display:flex;flex-wrap:wrap;align-content:center;');
    // }
    if ((ev || button) && this.isScrollbarPresent) {
      console.log("called");
      button?.classList?.add('web-start-btn-fixed');
    } else {
       let btn = document.getElementsByClassName("web-start-btn-fixed");
      if (btn && btn?.length>0) {
         divEle[0].setAttribute('style', 'height:auto !important;align-items:center; justify-content:center;display:flex;flex-wrap:wrap;align-content:center;');
      }
      
       //button?.classList?.remove('web-start-btn-fixed');

    }
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.isTouchDevice = this.sessionService.isTabletDevice();
    this.checkScrollbar();
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

}
